module.exports = __webpack_public_path__ + "static/img/wzry-companyProfile.08199fd3.png";